<ngx-spinner [name]="spinner1" [fullScreen]="true"><span class="badge badge-info p-2">Autorisierung wird durchgeführt...</span></ngx-spinner>
<div class="modal-header">
  <h5 class="modal-title" id="shareRFIDLabel" i18n="@@AssignRFID-CardToUserHeader">RFID-Karte bearbeiten</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">

  <div class="row">
    <div class="col">
      <h5 i18n="@@EditRfidCardIdTagLabel">RFID-Kartennummer:</h5>
    </div>
    <div class="col">
      <h5 id="card_number" style="font-weight:bold;">{{ rfidCard?.idTag }}</h5>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <span i18n="@@EditRfidCardLastAuthorizationLabel">Letzte Autorisierung:</span>
    </div>
    <div class="col">
      <span id="date">{{ rfidCard?.lastAuthorizationDate | dateDE }}</span>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <span i18n="@@EditRfidCardLastUsedChargingStationLabel">Letzte genutzte Ladestation:</span>
    </div>
    <div class="col">
      <span id="last_station">{{ rfidCard?.lastUsedChargingStationName }}</span>
    </div>
  </div>

  <br />

  <form [formGroup]="form" *ngIf="formCreated">
    <label for="users" class="form-label persistent" i18n="@@UserLabel">Benutzer</label>
    <ng-select #userSelect id="user"
      [appendTo]="'body'"
      [items]="users"
      bindLabel="fullName"
      autofocus
      bindValue="id"
      formControlName="selectedUserId"
      placeholder="Benutzer"
      i18n-placeholder="@@Users"
    >
    </ng-select>

    <label for="tags" class="form-label persistent mt-2" i18n="@@TagsLabel">Tags</label>
    <ng-select #tagsSelect id="tags"
      [addTag]="addTagRef"
      [appendTo]="'body'"
      [items]="tags"
      multiple="true"
      [hideSelected]="true"
      [closeOnSelect]="false" 
      [clearSearchOnAdd]="true"
      bindLabel="name"
      formControlName="selectedTags"
      placeholder="Tags"
      i18n-placeholder="@@Tags"
      i18n-notFoundText="@@NoEntriesAvailable"
      notFoundText="Keine Einträge vorhanden"
               >

      <ng-template ng-tag-tmp let-search="searchTerm">
        <b>Tag anlegen</b>: {{ search }}
      </ng-template>
    </ng-select>

    <label for="note" i18n="@@NoteLabel" class="persistent mt-2">Notiz</label>
    <input type="text" id="note" formControlName="note" class="form-control" placeholder="Notiz" i18n-placeholder="@@Note"/>
  </form>
</div>
<div class="modal-footer">
    <div class="col align-content-start justify-content-start" *ngIf="this.isOperatorView || this.customer">
      <button (click)="onDelete()" id="delete" class="btn btn bg-danger text-white" ngbTooltip="RFID-Karte löschen" i18n-ngbTooltip="@@DeleteRfidCardTooltip">
        <app-svg source="icons/feather/trash" height="18"></app-svg>
      </button>
    </div>
    <div class="col-auto text-end align-content-end justify-content-end">
      <button type="button" id="cancel" class="btn text-white me-1" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</button>
      <button type="button" id="save" class="btn btn-save" data-bs-dismiss="modal" [disabled]="!form?.valid || !form?.dirty" (click)="updateRfidCard()" i18n="@@SaveRfidCardButton">
        Änderungen speichern
      </button>
    </div>
</div>
